
import { supabase, invokeFunction } from '@/integrations/supabase/client';

export const fetchAllOrganisationData = async (
  connectionId: string,
  schema?: string,
  tableName?: string,
  filters?: Array<{ column: string; value: string; operation: string }>,
  organisationId?: string
): Promise<any[]> => {
  try {
    // Look up the correct database name from csv_import_jobs table
    let dbName = `figabl_${connectionId.replace(/[^a-zA-Z0-9]/g, '_')}`; // fallback

    try {
      const { data: importJob } = await supabase
        .from('csv_import_jobs')
        .select('database_name')
        .eq('connection_id', connectionId)
        .single();

      if (importJob?.database_name) {
        dbName = importJob.database_name;
      }
      // const { data: exactMatch } = await supabase
      //   .from('csv_import_jobs')
      //   .select('database_name')
      //   .eq('connection_id', connectionId)
      //   .single();

      // if (exactMatch?.database_name) {
      //   dbName = exactMatch.database_name;
      // } else if (organisationId) {
      //   // Fallback: Find completed job for THIS organisation
      //   const { data: orgJobs } = await supabase
      //     .from('csv_import_jobs')
      //     .select('database_name, connection_id')
      //     .eq('organisation_id', organisationId)
      //     .eq('status', 'completed')
      //     .not('database_name', 'is', null)
      //     .order('created_at', { ascending: false })
      //     .limit(1);

      //   if (orgJobs && orgJobs.length > 0) {
      //     dbName = orgJobs[0].database_name;
      //     console.log(`Using database from org's completed job: ${dbName}`);
      //   }
      // }
    } catch (error) {
      console.log('Could not find database name in csv_import_jobs, using fallback:', dbName);
    }

    // Use a higher timeout for full data exports
    const queryTimeout = 180000; // 3 minutes

    const response = await invokeFunction(supabase, 'query-organisation-data', {
      body: {
        dbName,
        connectionId,
        schema: schema || "public",
        tableName,
        rowLimit: null, // No limit for full export
        queryTimeout,
        usePagination: false, // Disable pagination
        exportMode: true, // Flag to indicate this is for export
        filters: filters || [],
        enableRetry: true
      }
    });

    if (response.error) {
      console.error('Error fetching all organization data:', response.error);
      throw new Error(`Error fetching organization data: ${response.error.message}`);
    }

    if (!response.data || !response.data.success) {
      console.error('Failed to fetch all organization data:', response.data?.error || 'No data returned');
      throw new Error(`Failed to fetch organization data: ${response.data?.error || 'No data returned'}`);
    }

    return response.data.records || [];
  } catch (error) {
    console.error('Error fetching all organization data:', error);
    throw error;
  }
};
